function buildViewIdParam(viewId) {
  return viewId ? `&view=${viewId}` : ''
}

export default (client) => {
  return {
    fetchAll(tableId, rowId, { offset = 0, limit = 50, viewId = null }) {
      return client.get(
        `/row_comments/${tableId}/${rowId}/?offset=${offset}&limit=${limit}${buildViewIdParam(viewId)}`
      )
    },
    create(tableId, rowId, message, { viewId = null, assignee = null } = {}) {
      const body = { message }
      if (assignee !== null) {
        body.assignee = assignee
      }
      return client.post(
        `/row_comments/${tableId}/${rowId}/?${buildViewIdParam(viewId)}`,
        body
      )
    },
    update(tableId, commentId, message, { viewId = null } = {}) {
      return client.patch(
        `/row_comments/${tableId}/comment/${commentId}/?${buildViewIdParam(viewId)}`,
        {
          message,
        }
      )
    },
    delete(tableId, commentId, { viewId = null } = {}) {
      return client.delete(
        `/row_comments/${tableId}/comment/${commentId}/?${buildViewIdParam(viewId)}`
      )
    },
    // Origem Flow: item de ação — atribuir (id ou null) e/ou resolver.
    updateActionItem(tableId, commentId, values, { viewId = null } = {}) {
      return client.patch(
        `/row_comments/${tableId}/comment/${commentId}/action-item/?${buildViewIdParam(viewId)}`,
        values
      )
    },
    updateNotificationMode(tableId, rowId, mode, { viewId = null } = {}) {
      return client.put(
        `/row_comments/${tableId}/${rowId}/notification-mode/?${buildViewIdParam(viewId)}`,
        { mode }
      )
    },
  }
}
